import { useState } from "react";
import { PenTool, Megaphone, Layers, Mic, Camera, ArrowUpRight } from "lucide-react";
import { SERVICIOS } from "../lib/content";

const ICON_MAP = { PenTool, Megaphone, Layers, Mic, Camera };

export default function Services() {
  const [active, setActive] = useState(0);

  return (
    <section
      id="servicios"
      data-testid="services-section"
      className="relative bg-[#FCFAFF] py-24 md:py-32 lg:py-40"
    >
      <div className="max-w-7xl mx-auto px-6 md:px-10 lg:px-14">
        {/* Section header */}
        <div className="flex items-center gap-3 mb-10">
          <span className="font-body uppercase text-[11px] tracking-[0.32em] text-[var(--ms-purple)] font-bold">
            04 / Servicios
          </span>
          <span className="flex-1 h-px bg-[var(--ms-border)]" />
        </div>

        <div className="grid grid-cols-12 gap-6 lg:gap-12 mb-16">
          <h2
            data-testid="services-heading"
            className="col-span-12 md:col-span-7 font-display font-medium text-5xl md:text-6xl lg:text-7xl leading-[0.95] tracking-tight text-[var(--ms-ink)]"
          >
            Servicios de <br />
            <span className="font-editorial italic font-light text-[var(--ms-purple)]">
              Marketing Sublime.
            </span>
          </h2>
          <p className="col-span-12 md:col-span-5 md:pt-8 font-body text-base md:text-lg leading-[1.75] text-[var(--ms-gray)]">
            Una oferta integral que combina diseño, estrategia y cultura digital para impulsar marcas hacia su máximo potencial de visibilidad y prestigio.
          </p>
        </div>

        {/* Service rows */}
        <ul className="border-t border-[var(--ms-border)]" data-testid="services-list">
          {SERVICIOS.map((s, i) => {
            const Icon = ICON_MAP[s.icon];
            const isActive = active === i;
            return (
              <li
                key={s.title}
                data-testid={`service-row-${i}`}
                onMouseEnter={() => setActive(i)}
                className={`group relative border-b border-[var(--ms-border)] transition-all duration-500 cursor-default ${
                  isActive ? "bg-[var(--ms-purple)]" : "bg-transparent hover:bg-[var(--ms-purple)]/[0.03]"
                }`}
              >
                <div className="grid grid-cols-12 gap-4 items-center px-2 md:px-4 py-7 md:py-9">
                  <div className={`col-span-1 font-display text-sm md:text-base ${isActive ? "text-white/60" : "text-[var(--ms-gray)]"}`}>
                    0{i + 1}
                  </div>
                  <div className="col-span-11 md:col-span-5 flex items-center gap-4">
                    <div className={`w-11 h-11 rounded-full flex items-center justify-center shrink-0 transition-colors duration-500 ${
                      isActive ? "bg-white/15 text-white" : "bg-[var(--ms-purple)]/10 text-[var(--ms-purple)]"
                    }`}>
                      <Icon size={18} />
                    </div>
                    <h3 className={`font-display font-medium text-xl md:text-2xl lg:text-3xl tracking-tight transition-colors duration-500 ${
                      isActive ? "text-white" : "text-[var(--ms-ink)]"
                    }`}>
                      {s.title}
                    </h3>
                  </div>
                  <p className={`hidden md:block col-span-5 font-body text-sm leading-relaxed transition-colors duration-500 ${
                    isActive ? "text-white/85" : "text-[var(--ms-gray)]"
                  }`}>
                    {s.desc}
                  </p>
                  <div className="col-span-1 flex justify-end">
                    <ArrowUpRight
                      size={20}
                      className={`transition-all duration-500 ${
                        isActive ? "text-white rotate-0" : "text-[var(--ms-ink)]/40 -rotate-45"
                      }`}
                    />
                  </div>
                </div>
                {/* Mobile description */}
                <p className={`md:hidden px-2 pb-7 font-body text-sm leading-relaxed ${
                  isActive ? "text-white/85" : "text-[var(--ms-gray)]"
                }`}>
                  {s.desc}
                </p>
              </li>
            );
          })}
        </ul>
      </div>
    </section>
  );
}
